/**
 * 加入我們
 * Created at 2021-10-02 15:55、
 * 这里是真不想改 就这样吧  没心思改
 * 
 * ？
 * @author teapot
 */
import "./index.css";
import { Button, Form, Image, Input, message } from "antd";
import { useTranslation } from "react-i18next";
import { useState } from "react";
import joinImg from "./images/join.png";
import http from "../../../service/http";
import joinus from './images/joinus.png'
import joinjt from './images/joinjt.png'
import { locals } from '../../../i18n'
import JoinusAddress from "./JoinusAddress";
const JoinUs = () => {
  const { t } = useTranslation();
  const [imgs, setImgs] = useState<any>();
  const [fileUrl, setFileUrl] = useState<string | null>(null);
  return (
    <>
      <div className="join join-pc">
        <JoinusAddress></JoinusAddress>
        {/* <div className="line"></div> */}
        <div className="join-center">
          <div className="join-placeholder addweare">
            <Image width={'100%'}  alt={"加入我们"} src={joinImg} preview={false} />
          </div>
        <div className="join-rights">
           
              <Image width={'250px'} alt={"加入我们"} src={locals() ==='zh-CN'  ? joinjt: joinus}  preview={false} />
           
            <div
              className="join-placeholder join-right"
              dangerouslySetInnerHTML={{ __html: t("join_desc") }}
            />
            
     </div>

        </div>

        <Form
          onFinish={(value) => {
            const params = value;
            const qualification: { position: string; date: string }[] = [];
            if (params.qualification1 && params.qualification_date1) {
              const obj = {
                position: params.qualification1,
                date: params.qualification_date1,
              };
              qualification.push(obj);
            }
            if (params.qualification2 && params.qualification_date2) {
              const obj = {
                position: params.qualification2,
                date: params.qualification_date2,
              };
              qualification.push(obj);
            }

            params.qualification = qualification;

            const once_worked: { position: string; date: string }[] = [];

            if (params.once_worked1 && params.once_worked11) {
              const obj = {
                position: params.once_worked1,
                date: params.once_worked11,
              };
              once_worked.push(obj);
            }

            if (params.once_worked2 && params.once_worked22) {
              const obj = {
                position: params.once_worked2,
                date: params.once_worked22,
              };
              once_worked.push(obj);
            }

            if (params.once_worked3 && params.once_worked33) {
              const obj = {
                position: params.once_worked3,
                date: params.once_worked33,
              };
              once_worked.push(obj);
            }

            if (params.once_worked4 && params.once_worked44) {
              const obj = {
                position: params.once_worked4,
                date: params.once_worked44,
              };
              once_worked.push(obj);
            }

            params.once_worked = once_worked;
            let formdata = new FormData();

            formdata.append("img", imgs);
            formdata.append("data", JSON.stringify(params));

            http
              .post("/about/application", formdata, {
                headers: {
                  "Content-Type": "multipart/form-data",
                },
              })
              .then((res) => {
                if (res && res.status === 200) {
                  message.success("提交成功");
                } else {
                  message.error("提交失败");
                }
              })
              .catch(() => {
                message.error("提交失败");
              });
          }}
        >
          <div className="apply">
            {/* 標題 */}
            <div className="apply-title">
              <div className="title-line"></div>
              <div className="title-text">{t("join_us_apply")}</div>
              <div className="title-line"></div>
            </div>

            {/* 佔位 */}
            <div className="apply-height" />

            <div className="info-top-left-row">
              <div className="info-top-left join-placeholder">
                {/* 中文名 ➕ 生日 */}
                <div className="info-top-left-row">
                  {/* 輸入框 */}
                  <div className="input-info">
                    <div className="triangle-topleft"></div>
                    <div className="parallelogram">
                      <div className="parallelogram-text">
                        {t("join_us_name_zh")}
                      </div>
                    </div>
                    <Form.Item
                      style={{ margin: 0, flex: 1, overflow: "hidden" }}
                      name="name"
                    >
                      <Input className="input-info-input" />
                    </Form.Item>
                  </div>

                  <div className="input-info">
                    <div className="triangle-topleft"></div>
                    <div className="parallelogram">
                      <div className="parallelogram-text">
                        {t("join_us_birth")}
                      </div>
                    </div>

                    <Form.Item
                      style={{ margin: 0, flex: 1, overflow: "hidden" }}
                      name="birthdate"
                    >
                      <Input className="input-info-input" />
                    </Form.Item>
                  </div>
                </div>

                {/* 英文名 ➕ 身份证号 */}
                <div className="info-top-left-row">
                  {/* 輸入框 */}
                  <div className="input-info">
                    <div className="triangle-topleft"></div>
                    <div className="parallelogram">
                      <div className="parallelogram-text">
                        {t("join_us_name_en")}
                      </div>
                    </div>
                    <Form.Item
                      style={{ margin: 0, flex: 1, overflow: "hidden" }}
                      name="e_name"
                    >
                      <Input className="input-info-input" />
                    </Form.Item>
                  </div>

                  <div className="input-info">
                    <div className="triangle-topleft"></div>
                    <div className="parallelogram">
                      <div className="parallelogram-text">
                        {t("join_us_id_card")}
                      </div>
                    </div>
                    <Form.Item
                      style={{ margin: 0, flex: 1, overflow: "hidden" }}
                      name="id_number"
                    >
                      <Input className="input-info-input" />
                    </Form.Item>
                  </div>
                </div>

                {/* 国籍 ➕ 籍贯 */}
                <div className="info-top-left-row">
                  {/* 輸入框 */}
                  <div className="input-info">
                    <div className="triangle-topleft"></div>
                    <div className="parallelogram">
                      <div className="parallelogram-text">
                        {t("join_us_nationality")}
                      </div>
                    </div>
                    <Form.Item
                      style={{ margin: 0, flex: 1, overflow: "hidden" }}
                      name="nation"
                    >
                      <Input className="input-info-input" />
                    </Form.Item>
                  </div>

                  <div className="input-info">
                    <div className="triangle-topleft"></div>
                    <div className="parallelogram">
                      <div className="parallelogram-text">
                        {t("join_us_hometown")}
                      </div>
                    </div>
                    <Form.Item
                      style={{ margin: 0, flex: 1, overflow: "hidden" }}
                      name="hometown"
                    >
                      <Input className="input-info-input" />
                    </Form.Item>
                  </div>
                </div>
              </div>
              {/* 上传头像 */}
              <div style={{ marginLeft: "15px" }}>
                {fileUrl ? (
                  <div className="info-top-right">
                    <img
                      alt={"head-icon"}
                      src={fileUrl}
                      style={{ width: 104, height: 134 }}
                    />
                  </div>
                ) : (
                  <div
                    className="info-top-right info-top-right-bg"
                    onClick={() => { }}
                  >
                    <Input
                      type="file"
                      className="inputxxx"
                      onChange={(event) => {
                        if (
                          event.target &&
                          event.target.files &&
                          event.target.files[0]
                        ) {
                          setImgs(event.target.files[0]);
                          const imageUrl = URL.createObjectURL(
                            event.target.files[0]
                          );
                          setFileUrl(imageUrl);
                        }
                      }}
                    />
                  </div>
                )}
              </div>
            </div>

            <div className="middle-line"></div>

            {/* 任職 ➕ 單位 */}
            <div className="info-top-left-row">
              {/* 輸入框 */}
              <div
                className="input-info"
                style={{ flex: 1, border: "#7B6A58 1px solid" }}
              >
                <div className="triangle-topleft2"></div>
                <div
                  className="parallelogram"
                  style={{ backgroundColor: "#7B6A58" }}
                >
                  <div className="parallelogram-text" style={{ color: "#fff" }}>
                    {t("join_us_job")}
                  </div>
                </div>
                <Form.Item
                  style={{ margin: 0, flex: 1, overflow: "hidden" }}
                  name="organization"
                >
                  <Input className="input-info-input" />
                </Form.Item>
              </div>

              <div
                className="input-info"
                style={{ border: "#7B6A58 1px solid" }}
              >
                <div className="triangle-topleft2"></div>
                <div
                  className="parallelogram"
                  style={{ backgroundColor: "#7B6A58" }}
                >
                  <div className="parallelogram-text" style={{ color: "#fff" }}>
                    {t("join_us_unit")}
                  </div>
                </div>
                <Form.Item
                  style={{ margin: 0, flex: 1, overflow: "hidden" }}
                  name="position"
                >
                  <Input className="input-info-input" />
                </Form.Item>
              </div>
            </div>

            {/* 辦公室地址 */}
            <div
              className="input-info"
              style={{ width: "100%", border: "#7B6A58 1px solid" }}
            >
              <div className="triangle-topleft2"></div>
              <div
                className="parallelogram"
                style={{ backgroundColor: "#7B6A58" }}
              >
                <div className="parallelogram-text" style={{ color: "#fff" }}>
                  {t("join_us_office")}
                </div>
              </div>
              <Form.Item
                style={{ margin: 0, flex: 1, overflow: "hidden" }}
                name="office"
              >
                <Input className="input-info-input" />
              </Form.Item>
            </div>

            {/* 學歷 ➕ 畢業年份 */}
            <div className="input-info2" style={{ height: "36px" }}>
              <div className="triangle-topleft2"></div>
              <div
                className="parallelogram"
                style={{
                  backgroundColor: "#7B6A58",
                  marginLeft: "3px",
                }}
              >
                <div className="parallelogram-text" style={{ color: "#fff" }}>
                  {t("join_us_education")}
                </div>
              </div>
              <div className="input-box">
                <Form.Item
                  name="education"
                  style={{ margin: 0, flex: 1, overflow: "hidden" }}
                >
                  <Input className="input-info-input" />
                </Form.Item>
              </div>

              <div
                className="parallelogram"
                style={{ backgroundColor: "#7B6A58" }}
              >
                <div className="parallelogram-text" style={{ color: "#fff" }}>
                  {t("join_us_graduation")}
                </div>
              </div>
              <div className="input-box">
                <Form.Item
                  name="education_date"
                  style={{ margin: 0, flex: 1, overflow: "hidden" }}
                >
                  <Input className="input-info-input" />
                </Form.Item>
              </div>
            </div>

            {/* 专业资格 ➕ 获取年份 */}
            <div className="input-info2">
              <div className="triangle-topleft3"></div>
              <div
                className="parallelogram"
                style={{
                  backgroundColor: "#7B6A58",
                  marginLeft: "3px",
                }}
              >
                <div className="parallelogram-text" style={{ color: "#fff" }}>
                  {t("join_us_qualifications")}
                </div>
              </div>
              <div className="input-box">
                <Form.Item
                  name="qualification1"
                  style={{ margin: 0, flex: 1, overflow: "hidden" }}
                >
                  <Input className="input-info-input" />
                </Form.Item>
                <Form.Item
                  name="qualification2"
                  style={{ margin: 0, flex: 1, overflow: "hidden" }}
                >
                  <Input className="input-info-input" />
                </Form.Item>
              </div>

              <div
                className="parallelogram"
                style={{ backgroundColor: "#7B6A58" }}
              >
                <div className="parallelogram-text" style={{ color: "#fff" }}>
                  {t("join_us_year_of_get")}
                </div>
              </div>
              <div className="input-box">
                <Form.Item
                  name="qualification_date1"
                  style={{ margin: 0, flex: 1, overflow: "hidden" }}
                >
                  <Input className="input-info-input" />
                </Form.Item>
                <Form.Item
                  name="qualification_date2"
                  style={{ margin: 0, flex: 1, overflow: "hidden" }}
                >
                  <Input className="input-info-input" />
                </Form.Item>
              </div>
            </div>

            {/* 研究内容  */}
            <div className="input-info2" style={{ height: "36px" }}>
              <div className="triangle-topleft2"></div>
              <div
                className="parallelogram"
                style={{
                  backgroundColor: "#7B6A58",
                  marginLeft: "3px",
                }}
              >
                <div className="parallelogram-text" style={{ color: "#fff" }}>
                  {t("join_us_content")}
                </div>
              </div>
              <div className="input-box">
                <Form.Item
                  name="research"
                  style={{ margin: 0, flex: 1, overflow: "hidden" }}
                >
                  <Input className="input-info-input" />
                </Form.Item>
              </div>
            </div>

            {/* 曾任公职 ➕ 担任年份 */}
            <div className="input-info2" style={{ height: "128px" }}>
              <div className="triangle-topleft4"></div>
              <div
                className="parallelogram"
                style={{
                  backgroundColor: "#7B6A58",
                  marginLeft: "3px",
                }}
              >
                <div className="parallelogram-text" style={{ color: "#fff" }}>
                  {t("join_us_employment")}
                </div>
              </div>
              <div className="input-box">
                <Form.Item
                  name="once_worked1"
                  style={{ margin: 0, flex: 1, overflow: "hidden" }}
                >
                  <Input className="input-info-input" />
                </Form.Item>
                <Form.Item
                  name="once_worked2"
                  style={{ margin: 0, flex: 1, overflow: "hidden" }}
                >
                  <Input className="input-info-input" />
                </Form.Item>
                <Form.Item
                  name="once_worked3"
                  style={{ margin: 0, flex: 1, overflow: "hidden" }}
                >
                  <Input className="input-info-input" />
                </Form.Item>
                <Form.Item
                  name="once_worked4"
                  style={{ margin: 0, flex: 1, overflow: "hidden" }}
                >
                  <Input className="input-info-input" />
                </Form.Item>
              </div>

              <div
                className="parallelogram"
                style={{ backgroundColor: "#7B6A58" }}
              >
                <div className="parallelogram-text" style={{ color: "#fff" }}>
                  {t("join_us_year_of_employment")}
                </div>
              </div>
              <div className="input-box">
                <Form.Item
                  name="once_worked11"
                  style={{ margin: 0, flex: 1, overflow: "hidden" }}
                >
                  <Input className="input-info-input" />
                </Form.Item>
                <Form.Item
                  name="once_worked22"
                  style={{ margin: 0, flex: 1, overflow: "hidden" }}
                >
                  <Input className="input-info-input" />
                </Form.Item>
                <Form.Item
                  name="once_worked33"
                  style={{ margin: 0, flex: 1, overflow: "hidden" }}
                >
                  <Input className="input-info-input" />
                </Form.Item>
                <Form.Item
                  name="once_worked44"
                  style={{ margin: 0, flex: 1, overflow: "hidden" }}
                >
                  <Input className="input-info-input" />
                </Form.Item>
              </div>
            </div>

            {/* 推荐人 ➕ 签署 */}
            <div className="input-info2">
              <div className="triangle-topleft3"></div>
              <div
                className="parallelogram"
                style={{
                  backgroundColor: "#7B6A58",
                  marginLeft: "3px",
                }}
              >
                <div className="parallelogram-text" style={{ color: "#fff" }}>
                  {t("join_us_referrer")}
                </div>
              </div>
              <div className="input-box">
                <Form.Item
                  label={t("join_us_telephone")}
                  name="referrer"
                  style={{ margin: 0, flex: 1, overflow: "hidden" }}
                >
                  <Input className="input-info-input" />
                </Form.Item>
                <Form.Item
                  label={t("join_us_sign")}
                  name="applicant"
                  style={{ margin: 0, flex: 1, overflow: "hidden" }}
                >
                  <Input className="input-info-input" />
                </Form.Item>
              </div>

              <div
                className="parallelogram"
                style={{ backgroundColor: "#7B6A58" }}
              >
                <div className="parallelogram-text" style={{ color: "#fff" }}>
                  {t("join_us_apply_people")}
                </div>
              </div>
              <div className="input-box">
                <div
                  className="input-info-input"
                  style={{
                    backgroundColor: "#fff",
                    opacity: 0,
                    margin: 0,
                    padding: 0,
                  }}
                />
                <Form.Item
                  label={t("join_us_date")}
                  name="application_date"
                  style={{ margin: 0, flex: 1, overflow: "hidden" }}
                >
                  <Input className="input-info-input" />
                </Form.Item>
              </div>
            </div>

            <div className="apply-foot">
              <div className="apply-foot-title">
                <div className="apply-foot-text">{t("join_us_info")}</div>
                <div className="apply-foot-triangle"></div>
              </div>
            </div>

            <div className="apply-foot-tip">{t("join_us_info_tip")}</div>
          </div>
          <div
            style={{
              width: "100%",
              alignItems: "center",
              justifyContent: "center",
              display: "flex",
              paddingTop: "15px",
            }}
          >
            <Form.Item>
              <Button style={{ backgroundColor: "#a48a7b" }} htmlType="submit">
                {t("join_us_submit")}
              </Button>
            </Form.Item>
          </div>
        </Form>
      </div>

      <div className="join join-phone">
        <Image alt={"加入我们"} src={joinImg} preview={false} />
        <div dangerouslySetInnerHTML={{ __html: t("join_desc") }} />

        <Form
          onFinish={(value) => {
            const params = value;
            const qualification: { position: string; date: string }[] = [];
            if (params.qualification1 && params.qualification_date1) {
              const obj = {
                position: params.qualification1,
                date: params.qualification_date1,
              };
              qualification.push(obj);
            }
            if (params.qualification2 && params.qualification_date2) {
              const obj = {
                position: params.qualification2,
                date: params.qualification_date2,
              };
              qualification.push(obj);
            }

            params.qualification = qualification;

            const once_worked: { position: string; date: string }[] = [];

            if (params.once_worked1 && params.once_worked11) {
              const obj = {
                position: params.once_worked1,
                date: params.once_worked11,
              };
              once_worked.push(obj);
            }

            if (params.once_worked2 && params.once_worked22) {
              const obj = {
                position: params.once_worked2,
                date: params.once_worked22,
              };
              once_worked.push(obj);
            }

            if (params.once_worked3 && params.once_worked33) {
              const obj = {
                position: params.once_worked3,
                date: params.once_worked33,
              };
              once_worked.push(obj);
            }

            if (params.once_worked4 && params.once_worked44) {
              const obj = {
                position: params.once_worked4,
                date: params.once_worked44,
              };
              once_worked.push(obj);
            }

            params.once_worked = once_worked;
            let formdata = new FormData();

            formdata.append("img", imgs);
            formdata.append("data", JSON.stringify(params));

            http
              .post("/about/application", formdata, {
                headers: {
                  "Content-Type": "multipart/form-data",
                },
              })
              .then((res) => {
                if (res && res.status === 200) {
                  message.success("提交成功");
                } else {
                  message.error("提交失败");
                }
              })
              .catch(() => {
                message.error("提交失败");
              });
          }}
        >
          <div className="apply-phone">
            {/* 上传头像 */}
            <div
              className="join-flex"
              style={{
                alignItems: "flex-end",
              }}
            >
              {fileUrl ? (
                <div className="info-top-right">
                  <img
                    alt={"head-icon"}
                    src={fileUrl}
                    style={{ width: 104, height: 134 }}
                  />
                </div>
              ) : (
                <div
                  className="info-top-right info-top-right-bg"
                  onClick={() => { }}
                >
                  <Input
                    type="file"
                    className="inputxxx"
                    onChange={(event) => {
                      if (
                        event.target &&
                        event.target.files &&
                        event.target.files[0]
                      ) {
                        setImgs(event.target.files[0]);
                        const imageUrl = URL.createObjectURL(
                          event.target.files[0]
                        );
                        setFileUrl(imageUrl);
                      }
                    }}
                  />
                </div>
              )}

              <span style={{ marginLeft: '10px' }}>{t("join_us_photo")}</span>
            </div>

            <div
              className="input-info"
              style={{ width: "100%", marginTop: "10px" }}
            >
              <div className="triangle-topleft"></div>
              <div className="parallelogram">
                <div className="parallelogram-text">{t("join_us_name_zh")}</div>
              </div>
              <Form.Item
                style={{ margin: 0, flex: 1, overflow: "hidden" }}
                name="name"
              >
                <Input className="input-info-input" />
              </Form.Item>
            </div>

            <div className="input-info" style={{ width: "100%" }}>
              <div className="triangle-topleft"></div>
              <div className="parallelogram">
                <div className="parallelogram-text">{t("join_us_birth")}</div>
              </div>

              <Form.Item
                style={{ margin: 0, flex: 1, overflow: "hidden" }}
                name="birthdate"
              >
                <Input className="input-info-input" />
              </Form.Item>
            </div>

            <div className="input-info" style={{ width: "100%" }}>
              <div className="triangle-topleft"></div>
              <div className="parallelogram">
                <div className="parallelogram-text">{t("join_us_name_en")}</div>
              </div>
              <Form.Item
                style={{ margin: 0, flex: 1, overflow: "hidden" }}
                name="e_name"
              >
                <Input className="input-info-input" />
              </Form.Item>
            </div>

            <div className="input-info" style={{ width: "100%" }}>
              <div className="triangle-topleft"></div>
              <div className="parallelogram">
                <div className="parallelogram-text">{t("join_us_id_card")}</div>
              </div>
              <Form.Item
                style={{ margin: 0, flex: 1, overflow: "hidden" }}
                name="id_number"
              >
                <Input className="input-info-input" />
              </Form.Item>
            </div>
            {/* 輸入框 */}
            <div className="input-info" style={{ width: "100%" }}>
              <div className="triangle-topleft"></div>
              <div className="parallelogram">
                <div className="parallelogram-text">
                  {t("join_us_nationality")}
                </div>
              </div>
              <Form.Item
                style={{ margin: 0, flex: 1, overflow: "hidden" }}
                name="nation"
              >
                <Input className="input-info-input" />
              </Form.Item>
            </div>

            <div className="input-info" style={{ width: "100%" }}>
              <div className="triangle-topleft"></div>
              <div className="parallelogram">
                <div className="parallelogram-text">
                  {t("join_us_hometown")}
                </div>
              </div>
              <Form.Item
                style={{ margin: 0, flex: 1, overflow: "hidden" }}
                name="hometown"
              >
                <Input className="input-info-input" />
              </Form.Item>
            </div>

            <div
              className="input-info"
              style={{ flex: 1, border: "#7B6A58 1px solid", width: "100%" }}
            >
              <div className="triangle-topleft2"></div>
              <div
                className="parallelogram"
                style={{ backgroundColor: "#7B6A58" }}
              >
                <div className="parallelogram-text" style={{ color: "#fff" }}>
                  {t("join_us_job")}
                </div>
              </div>
              <Form.Item
                style={{ margin: 0, flex: 1, overflow: "hidden" }}
                name="organization"
              >
                <Input className="input-info-input" />
              </Form.Item>
            </div>

            <div
              className="input-info"
              style={{ border: "#7B6A58 1px solid", width: "100%" }}
            >
              <div className="triangle-topleft2"></div>
              <div
                className="parallelogram"
                style={{ backgroundColor: "#7B6A58" }}
              >
                <div className="parallelogram-text" style={{ color: "#fff" }}>
                  {t("join_us_unit")}
                </div>
              </div>
              <Form.Item
                style={{ margin: 0, flex: 1, overflow: "hidden" }}
                name="position"
              >
                <Input className="input-info-input" />
              </Form.Item>
            </div>

            {/* 辦公室地址 */}
            <div
              className="input-info"
              style={{ width: "100%", border: "#7B6A58 1px solid" }}
            >
              <div className="triangle-topleft2"></div>
              <div
                className="parallelogram"
                style={{ backgroundColor: "#7B6A58" }}
              >
                <div className="parallelogram-text" style={{ color: "#fff" }}>
                  {t("join_us_office")}
                </div>
              </div>
              <Form.Item
                style={{ margin: 0, flex: 1, overflow: "hidden" }}
                name="office"
              >
                <Input className="input-info-input" />
              </Form.Item>
            </div>

            {/* 學歷 ➕ 畢業年份 */}
            <div className="input-info2" style={{ height: "36px" }}>
              <div className="triangle-topleft2"></div>
              <div
                className="parallelogram"
                style={{
                  backgroundColor: "#7B6A58",
                  marginLeft: "3px",
                }}
              >
                <div className="parallelogram-text" style={{ color: "#fff" }}>
                  {t("join_us_education")}
                </div>
              </div>
              <div className="input-box">
                <Form.Item
                  name="education"
                  style={{ margin: 0, flex: 1, overflow: "hidden" }}
                >
                  <Input className="input-info-input" />
                </Form.Item>
              </div>
            </div>

            <div
              className="input-info"
              style={{ width: "100%", border: "#7B6A58 1px solid" }}
            >
              <div className="triangle-topleft2"></div>
              <div
                className="parallelogram"
                style={{ backgroundColor: "#7B6A58" }}
              >
                <div className="parallelogram-text" style={{ color: "#fff" }}>
                  {t("join_us_graduation")}
                </div>
              </div>
              <Form.Item
                name="education_date"
                style={{ margin: 0, flex: 1, overflow: "hidden" }}
              >
                <Input className="input-info-input" />
              </Form.Item>
            </div>

            {/* 专业资格 ➕ 获取年份 */}
            <div className="input-info2">
              <div className="triangle-topleft3"></div>
              <div
                className="parallelogram"
                style={{
                  backgroundColor: "#7B6A58",
                  marginLeft: "3px",
                }}
              >
                <div className="parallelogram-text" style={{ color: "#fff" }}>
                  {t("join_us_qualifications")}
                </div>
              </div>
              <div className="input-box">
                <Form.Item
                  name="qualification1"
                  style={{ margin: 0, flex: 1, overflow: "hidden" }}
                >
                  <Input className="input-info-input" />
                </Form.Item>
                <Form.Item
                  name="qualification2"
                  style={{ margin: 0, flex: 1, overflow: "hidden" }}
                >
                  <Input className="input-info-input" />
                </Form.Item>
              </div>

              <div
                className="parallelogram"
                style={{ backgroundColor: "#7B6A58" }}
              >
                <div className="parallelogram-text" style={{ color: "#fff" }}>
                  {t("join_us_year_of_get")}
                </div>
              </div>
              <div className="input-box">
                <Form.Item
                  name="qualification_date1"
                  style={{ margin: 0, flex: 1, overflow: "hidden" }}
                >
                  <Input className="input-info-input" />
                </Form.Item>
                <Form.Item
                  name="qualification_date2"
                  style={{ margin: 0, flex: 1, overflow: "hidden" }}
                >
                  <Input className="input-info-input" />
                </Form.Item>
              </div>
            </div>

            {/* 研究内容  */}
            <div className="input-info2" style={{ height: "36px" }}>
              <div className="triangle-topleft2"></div>
              <div
                className="parallelogram"
                style={{
                  backgroundColor: "#7B6A58",
                  marginLeft: "3px",
                }}
              >
                <div className="parallelogram-text" style={{ color: "#fff" }}>
                  {t("join_us_content")}
                </div>
              </div>
              <div className="input-box">
                <Form.Item
                  name="research"
                  style={{ margin: 0, flex: 1, overflow: "hidden" }}
                >
                  <Input className="input-info-input" />
                </Form.Item>
              </div>
            </div>

            {/* 曾任公职 ➕ 担任年份 */}
            <div className="input-info2" style={{ height: "128px" }}>
              <div className="triangle-topleft4"></div>
              <div
                className="parallelogram"
                style={{
                  backgroundColor: "#7B6A58",
                  marginLeft: "3px",
                }}
              >
                <div className="parallelogram-text" style={{ color: "#fff" }}>
                  {t("join_us_employment")}
                </div>
              </div>
              <div className="input-box">
                <Form.Item
                  name="once_worked1"
                  style={{ margin: 0, flex: 1, overflow: "hidden" }}
                >
                  <Input className="input-info-input" />
                </Form.Item>
                <Form.Item
                  name="once_worked2"
                  style={{ margin: 0, flex: 1, overflow: "hidden" }}
                >
                  <Input className="input-info-input" />
                </Form.Item>
                <Form.Item
                  name="once_worked3"
                  style={{ margin: 0, flex: 1, overflow: "hidden" }}
                >
                  <Input className="input-info-input" />
                </Form.Item>
                <Form.Item
                  name="once_worked4"
                  style={{ margin: 0, flex: 1, overflow: "hidden" }}
                >
                  <Input className="input-info-input" />
                </Form.Item>
              </div>

              <div
                className="parallelogram"
                style={{ backgroundColor: "#7B6A58" }}
              >
                <div className="parallelogram-text" style={{ color: "#fff" }}>
                  {t("join_us_year_of_employment")}
                </div>
              </div>
              <div className="input-box">
                <Form.Item
                  name="once_worked11"
                  style={{ margin: 0, flex: 1, overflow: "hidden" }}
                >
                  <Input className="input-info-input" />
                </Form.Item>
                <Form.Item
                  name="once_worked22"
                  style={{ margin: 0, flex: 1, overflow: "hidden" }}
                >
                  <Input className="input-info-input" />
                </Form.Item>
                <Form.Item
                  name="once_worked33"
                  style={{ margin: 0, flex: 1, overflow: "hidden" }}
                >
                  <Input className="input-info-input" />
                </Form.Item>
                <Form.Item
                  name="once_worked44"
                  style={{ margin: 0, flex: 1, overflow: "hidden" }}
                >
                  <Input className="input-info-input" />
                </Form.Item>
              </div>
            </div>

            {/* 推荐人 ➕ 签署 */}
            <div
              style={{
                width: "100%",
                border: "#7b6a58 1px solid",
                display: "flex",
                flexDirection: "row",
                overflow: "hidden",
                marginRight: "10px",
                marginBottom: "15px",
              }}
            >
              <div className="triangle-topleft3"></div>
              <div>
                <div
                  className="parallelogram"
                  style={{
                    backgroundColor: "#7B6A58",
                    marginLeft: "3px",
                  }}
                >
                  <div className="parallelogram-text" style={{ color: "#fff" }}>
                    {t("join_us_referrer")}
                  </div>
                </div>
                <div className="input-box">
                  <Form.Item
                    label={t("join_us_telephone")}
                    name="referrer"
                    style={{ margin: 0, flex: 1, overflow: "hidden" }}
                  >
                    <Input className="input-info-input" />
                  </Form.Item>
                  <Form.Item
                    label={t("join_us_sign")}
                    name="applicant"
                    style={{ margin: 0, flex: 1, overflow: "hidden" }}
                  >
                    <Input className="input-info-input" />
                  </Form.Item>
                </div>

                <div
                  className="parallelogram"
                  style={{ backgroundColor: "#7B6A58" }}
                >
                  <div className="parallelogram-text" style={{ color: "#fff" }}>
                    {t("join_us_apply_people")}
                  </div>
                </div>
                <div className="input-box">
                  <div
                    className="input-info-input"
                    style={{
                      backgroundColor: "#fff",
                      opacity: 0,
                      margin: 0,
                      padding: 0,
                    }}
                  />
                  <Form.Item
                    label={t("join_us_date")}
                    name="application_date"
                    style={{ margin: 0, flex: 1, overflow: "hidden" }}
                  >
                    <Input className="input-info-input" />
                  </Form.Item>
                </div>
              </div>
            </div>

            <div className="apply-foot">
              <div className="apply-foot-title">
                <div className="apply-foot-text">{t("join_us_info")}</div>
                <div className="apply-foot-triangle"></div>
              </div>
            </div>

            <div className="apply-foot-tip">{t("join_us_info_tip")}</div>
          </div>

          <div
            style={{
              width: "100%",
              alignItems: "center",
              justifyContent: "center",
              display: "flex",
              paddingTop: "15px",
            }}
          >
            <Form.Item>
              <Button style={{ backgroundColor: "#a48a7b" }} htmlType="submit">
                {t("join_us_submit")}
              </Button>
            </Form.Item>
          </div>
        </Form>
      </div>
    </>
  );
};

export default JoinUs;
